import "./newTag.css";

export const NewTag = () => {
	return (
		<div className="d-flex align-items-center justify-content-center notification-tag">
			New
		</div>
	);
};
